export const BASE_URL = "https://portal.cspmeds.com/api/";
export const PRINT_URL = BASE_URL.replace('/api/','');
